import { Grid } from '@mui/material'
import * as React from 'react'
import { IMetricProps } from './types'
import { LabelMetric, ValueDesc, ValueMetric } from './styled'

const Metric: React.FC<IMetricProps> = ({ label, value, description }) => {
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={8}>
          <LabelMetric>{label}</LabelMetric>
        </Grid>
        <Grid item xs={11}>
          <ValueMetric>{value}</ValueMetric>
        </Grid>
        <Grid item xs={9}>
          <ValueDesc>{description}</ValueDesc>
        </Grid>
      </Grid>
    </>
  )
}

export default Metric
